import styled, { css } from 'styled-components';

import { base, colors } from '../../styles';


export const InputMaskAndCalendar = styled.div``;
